<template>
  <div class="sidebar">
    <div class="sidebar__links">
      <ul class="list">
        <li @click="trackPageClick(`sidebar_using_sitename`)">
          <router-link
            class="link"
            :to="{name: `using-site`}"
          >{{getTitle('using-site')}}</router-link>
        </li>
        <li class="line">|</li>
        <li @click="trackPageClick(`sidebar_billing_support`)">
          <router-link
            class="link"
            :to="{name: 'billing-support'}"
          >{{getTitle('billing-support')}}</router-link>
        </li>
        <li class="line">|</li>
        <li @click="trackPageClick(`sidebar_account_support`)">
          <router-link
            class="link"
            :to="{name: 'account-support'}"
          >{{getTitle('account-support')}}</router-link>
        </li>
        <li class="line">|</li>
        <li @click="trackPageClick(`sidebar_technical_support`)">
          <router-link
            class="link"
            :to="{name: 'technical-support'}"
          >{{getTitle('technical-support')}}</router-link>
        </li>
        <li class="line">|</li>
        <li @click="trackPageClick(`sidebar_partners_authors`)">
          <router-link
            class="link"
            :to="{name: 'partners-authors'}"
          >{{getTitle('partners-authors')}}</router-link>
        </li>
      </ul>
    </div>
    <div>
      <router-link class="link" :to="{name: 'home'}">
        <span class="icon icon-back-highlight">
          <svg width="4" height="7" viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.84704 0.154081C3.94498 0.252768 4 0.3866 4 0.526144C4 0.665688 3.94498 0.79952 3.84704 0.898207L1.26103 3.50318L3.84704 6.10815C3.9422 6.2074 3.99486 6.34033 3.99367 6.47832C3.99248 6.6163 3.93754 6.74829 3.84068 6.84586C3.74381 6.94344 3.61278 6.99878 3.4758 6.99998C3.33883 7.00118 3.20686 6.94814 3.10833 6.85227L0.152959 3.87524C0.0550196 3.77655 0 3.64272 0 3.50318C0 3.36363 0.0550196 3.2298 0.152959 3.13111L3.10833 0.154081C3.2063 0.0554229 3.33916 0 3.47768 0C3.61621 0 3.74907 0.0554229 3.84704 0.154081Z"/>
</svg>

        </span>
        <span class="text--theme-highlight">{{$t('sidebarTopLink')}}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { getCategoryPageName, trackPageClick } from '@/utils/common';

export default {
  computed: {
    siteName() {
      return this.$store.state.siteDetails.site_name;
    },
    categories() {
      return this.$store.state.categories;
    }
  },
  methods: {
    getCategoryName(categoryId) {
      return getCategoryPageName(categoryId, this.$store.state.flowObject.pages);
    },
    trackPageClick(clickName) {
      return trackPageClick(clickName);
    },
    getTitle(pageName) {
      return this.$store.state.categories[this.$store.state.flowObject.pages[pageName].meta.categoryId].title;
    }
  }
};
</script>

<style lang="scss" scoped>

.sidebar {
  svg {
    path {
      fill: #000;
    }
  }
}
.sidebar__links {
  ul {
    margin: 0 0 25px;
    padding: 0;
    list-style: none;
    display: flex;
    justify-content: space-between;
    font-family: Segoe UI, Arial, sans-serif;
    font-size: 12px;
    font-weight: 600;
  }
  li {
    margin: 0;
    position: relative;
    &.line {
      color: #ccc;
    }
  }
  .link {
    color: #000;
    display: block;
    padding: 0;
    border-left: 0;

    &:hover {
      color: #000;
      text-decoration: underline;
    }
  }
}
.text--theme-highlight {
  font-family: Segoe UI, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #000;
  text-transform: capitalize;
  display: inline-block;
  vertical-align: top;
  &:active,
  &:hover,
  &:focus {
    outline: none;
  }
}
.icon-back-highlight {
  display: inline-block;
  vertical-align: top;
  margin: 0px 10px 0 0;
  line-height: 1;
}
@media (max-width: 768px) {
  .content__aside .sidebar__links {
    display: none;
    ul {
      margin: 0 -10px 25px;
      flex-wrap: wrap;
      justify-content: center;
    }
    li {
      padding: 0 10px 5px;
      min-width: auto;
    }
  }
}

</style>
